<!--

	Member avatar with title and description

-->
<template>
	<div class="mia-TeamMember">
		<img class="mia-Image mia-teamMemberImage" :width="imageWidth" height="auto" :alt="$tr('TeamMemberAlt')" :src="item.PictureUrl" @click="showModal = true">
		<h3 class="mia-title h4">
			{{ item.Title }}
		</h3>
		<p class="mia-description">
			{{ item.About }}
		</p>
		<modal v-if="showModal" :initially-shown="true" :cross="cross" @close="showModal = false">
			<template #title>
				<h3 class="modal-title">
					{{ item.Title }}
				</h3>
			</template>
			<template #body>
				<img class="mia-Image mia-u-fillParentWidth" :src="item.PictureUrl">
			</template>
		</modal>
	</div>
</template>
<script lang="ts">
import { DefaultTeamMember } from "@/Control/Vue/Defaults";
import { Item } from "@/Control/Vue/Lists/VueList/Items/Item";
import { MiaPlaza } from "@/Reinforced.Typings";
import Cross from "@theme/cross.svg";
import { Component, toNative } from "vue-facing-decorator";
import Modal from "@/Control/Vue/Notifications/Modal.vue";

@Component({
	components: { Modal },
})
export class TeamMember extends Item<MiaPlaza.Control.Vue.ITeamMember> {
	protected defaults = DefaultTeamMember;

	showModal = false;

	readonly cross = Cross;

	imageWidth = '186px'; // equal to $mia-member-image-width
}

export default toNative(TeamMember);
</script>
<style lang="scss">
$mia-member-image-width: 186px;

.mia-TeamMember {
	background-color: theme.$mia-color-contrastPanel;
	color: theme.$mia-color-contrastPanel-font;
	padding: theme.$mia-padding-panel;
	display: inline-block;
	margin-bottom: theme.$mia-padding-panel;
	border-radius: theme.$mia-border-radius;

	.mia-teamMemberImage {
		float: left;
		margin-right: theme.$mia-padding-panel-large;
	}

	.mia-description {
		margin-bottom: 0;
	}

	@media (max-width: 480px) {
		.mia-teamMemberImage {
			float: inherit;
			margin-bottom: theme.$mia-margin-size;
		}
	}

	@media (min-width: theme.$screen-md-min) {
		.mia-description {
			margin-left: calc(#{theme.$mia-padding-panel-large} + #{$mia-member-image-width});
		}

		.mia-title h4 {
			margin-top: 0;
		}
	}
}
</style>
